import React, { Component, Suspense } from 'react';
import { Switch, Route } from 'react-router-dom';
import Loadable from 'react-loadable';
import { Toaster } from 'react-hot-toast';

import '../node_modules/font-awesome/scss/font-awesome.scss';
import '../src/assets/css/style.css'

import FullScreenLoader from './components/loaders/fullscreen-loader'
import ScrollToTop from './components/layout/scroll-to-top';
import PublicRoute, { publicRoutesList } from './public-routes';

const AdminLayout = Loadable({
    loader: () => import('./components/layout/layout'),
    loading: FullScreenLoader
});
class App extends Component {

    render() {
        const publicRoutes = publicRoutesList.map((route, index) => {
          return (route.component) ? (
              <PublicRoute key={index} component={route.component} {...route} />
          ) : (null)
        })

        return (
            <React.Fragment>
                <ScrollToTop>
                    <Suspense fallback={<FullScreenLoader/>}>
                        <Switch>
                            {publicRoutes}
                            <Route path='/' component={AdminLayout} />
                        </Switch>
                    </Suspense>
                    <Toaster />
                </ScrollToTop>
            </React.Fragment>
        );
    }
}

export default App;
